import { render, staticRenderFns } from "./PlanSelector.vue?vue&type=template&id=37de1736&scoped=true"
import script from "./PlanSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PlanSelector.vue?vue&type=style&index=0&id=37de1736&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37de1736",
  null
  
)

export default component.exports